import { showFromFade } from "../../js/Util";

if ($('.theme').length) {
    $('.theme').each((index, item) => {
        const start = $(document).width() >=  768 ? 'top bottom-=20%' : 'top bottom-=10%';
        showFromFade(item, start);
    });

    $(".theme")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}

if ($('.speakers').length) {
    $(".speakers")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}